import React, { FormEventHandler, MouseEventHandler } from "react";
import { useTranslation } from "react-i18next";
import { Organization } from "../common/ObjectTypes";
import { AttentionIcon } from "../common/ProjectIcons";
import { buttonClasses, inputClasses } from "../common/tailwindClassnames";
import ModalShell from "../common/ModalShell";
import RequiredTag from "../common/RequiredTag";

type OrganizationModalProps = {
    organization: Organization,
    onChange: Function,
    onToggleModal: MouseEventHandler,
    onSave: FormEventHandler,
    newOrg: boolean,
    errors: any,
    saveDisabled: boolean,
}

const OrganizationModal = ({
    organization,
    onChange,
    onToggleModal,
    onSave,
    newOrg,
    errors,
    saveDisabled,
}: OrganizationModalProps) => {
    const { t } = useTranslation();
    return (
        <ModalShell
            title={`${newOrg ? t("Add") : t("Update")} ${t("Workspace")}`}
            onClose={onToggleModal}
            footer={
                <>
                    <button
                        className={buttonClasses.primary}
                        type="submit"
                        form="org-modal-form"
                        disabled={saveDisabled}
                    >
                        {newOrg ? t("Create") : t("Save")}
                    </button>
                    <button
                        className={buttonClasses.cancel}
                        type="button"
                        onClick={onToggleModal}
                    >
                        {t("Cancel")}
                    </button>
                </>
            }
        >
            <form id="org-modal-form" onSubmit={(e) => { e.preventDefault(); onSave(e); }} className="flex flex-col gap-4">
                <div className="flex flex-col w-full">
                    <label className="text-ui-text-primary-text mb-1 transition-colors duration-300">{t("Name")}<RequiredTag /></label>
                    <input
                        id="name"
                        className={inputClasses.standard}
                        value={organization.name}
                        onChange={(e) => onChange(e)}
                    />
                    {errors.name && <div className="flex flex-row text-unlisted-orange-600 mt-1"><AttentionIcon /><p className="ml-1 mt-0.5">{errors.name}</p></div>}
                </div>
                <div className="flex flex-col w-full">
                    <label className="text-ui-text-primary-text mb-1 transition-colors duration-300">{t("Description")}</label>
                    <input
                        id="description"
                        className={inputClasses.standard}
                        value={organization.description}
                        onChange={(e) => onChange(e)}
                    />
                </div>
            </form>
        </ModalShell>
    );
};

export default OrganizationModal;
